import React from "react";
import { useEffect } from "react";
import { useRef, useState } from "react";

import { Suspense } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { OrbitControls, useGLTF } from "@react-three/drei";
import ReactMapGL, { Marker, Popup } from "react-map-gl";
import "./pstyle.css";
import { socket } from "../../src/socket";

import { useSelector } from "react-redux";
import translations from "../locals/translation";

import Swal from "sweetalert2";
import { performVerification } from "../commonFunc/verification";

import { useNavigate } from "react-router-dom";

function VendorLocation() {
  const language = useSelector((state) => state.language.value);
  const [popupInfo, setPopupInfo] = useState(null);
  const [showPopUp, setShowPopUp] = useState(false);

  const [truckCoordinates, setTruckCoordinates] = useState([
    { lat: 40.7128, lng: 74.006 }, // New York City
    { lat: 34.0522, lng: 118.2437 }, // Los Angeles
    { lat: 51.5074, lng: 0.1278 }, // London
    { lat: 48.8566, lng: 2.3522 }, // Paris
    // Add more coordinates as needed
  ]);
  const [userCoordinates, setUserCoordinates] = useState([
    { lat: 40.7128, lng: 74.006 }, // New York City
    { lat: 34.0522, lng: 118.2437 }, // Los Angeles
    { lat: 51.5074, lng: 0.1278 }, // London
    { lat: 48.8566, lng: 2.3522 }, // Paris
    // Add more coordinates as needed
  ]);
  const [viewport, setViewport] = useState({
    latitude: 22.66,
    longitude: 75.55,
    zoom: 5,
  });
  const t = (key) => {
    if (translations[language]) {
      const translation = translations[language][key];
      return translation !== undefined ? translation : key;
    } else {
      return key;
    }
  };
  const [setTruckData] = useState([]);
  const [runUE, setRunUE] = useState(false);
  const [runnUE3, setRunnUE3] = useState(false);
  const [setDmarkers] = useState([]);
  const [setDumarkers] = useState([]);

  ReactMapGL.accessToken =
    "pk.eyJ1IjoiYXNoYXlhdCIsImEiOiJjbHRyMmh4YmowYTJjMmtxbWgzZTd2a2JiIn0.TP0CZqeXTnQsaJXlBdRHrA";

  const TOKEN =
    "pk.eyJ1IjoiYXNoYXlhdCIsImEiOiJjbHRyMmh4YmowYTJjMmtxbWgzZTd2a2JiIn0.TP0CZqeXTnQsaJXlBdRHrA";

  const Data = {
    endPoint: "/getAllUsers",
    responseType: "user", // Added property to specify the type of response
    token: localStorage.getItem("token"),
  };
  const Data2 = {
    endPoint: "/getAllTrucks",
    responseType: "truck", // Added property to specify the type of response
    token: localStorage.getItem("token"),
  };
  function isValidNumber(data) {
    // Check if data is a string
    if (typeof data !== "string") {
      return false;
    }

    // Check if data can be converted to a valid number
    const number = Number(data);
    if (isNaN(number)) {
      return false;
    }

    // Check if data contains more than one dot
    const dotCount = data.split(".").length - 1;
    if (dotCount > 1) {
      return false;
    }

    // If all checks pass, data is a valid number
    return true;
  }

  const navigate = useNavigate();

  useEffect(() => {
    if (!performVerification()) {
      Swal.fire({ text: t("Login first"), icon: "warning" });
      navigate("/login");
    }
    socket.connect();
    socket.emit("API", JSON.stringify(Data));
    socket.emit("API", JSON.stringify(Data2));
    socket.on("APIResponse", (message) => {
      const parsedMessage = JSON.parse(message);

      if (parsedMessage.message === "Trucks Fetched Successfully") {
        setDmarkers([]);
        setTruckData(parsedMessage.truckData);
        const correctTruckData = parsedMessage.truckData.filter(
          (item) =>
            isValidNumber(item.lat) === true &&
            isValidNumber(item.long) === true
        );

        const filteredData = correctTruckData
          // eslint-disable-next-line array-callback-return
          .map((item, index) => {
            if (item.lat && item.long) {
              return {
                id: item.truck_id,
                lng: Number(item.long),
                lat: Number(item.lat),
                icon: "./img/truck.svg",
                username: item.username,
              };
            }
            // or any other appropriate action if lat and long are not present
          })
          .filter((item) => item !== null); // filtering out null values if any

        setDmarkers(filteredData);
        setTruckCoordinates(filteredData);
        setRunUE(!runUE);
        setRunnUE3(!runnUE3);
      } else {
        setDumarkers([]);
        const correctUserData = parsedMessage.userData.filter(
          (item) =>
            isValidNumber(item.lat) === true &&
            isValidNumber(item.long) === true
        );

        let mappedData5 = correctUserData.map((item5, index) => {
          return {
            id: index + 1,
            lng: Number(item5?.long),
            lat: Number(item5?.lat),
            icon: "./img/user.png",
          };
        });
        setDumarkers(mappedData5);
        setUserCoordinates(mappedData5);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function Model({ ...props }) {
    const group = useRef();
    const { nodes } = useGLTF("/demo-text.glb");

    useFrame(({ clock }) => {
      group.current.rotation.x = clock.getElapsedTime();
    });

    return (
      <group ref={group} {...props} dispose={null}>
        <group rotation={[-Math.PI / 2, 0, 0]} scale={1}>
          <mesh
            geometry={nodes["3D_Text_-_D"].geometry}
            material={nodes["3D_Text_-_D"].material}
            position={[-20.49, 1.55, 0.32]}
            scale={0.21}
          />
          <mesh
            geometry={nodes["3D_Text_-_e"].geometry}
            material={nodes["3D_Text_-_e"].material}
            position={[-14.18, 1.55, 0.12]}
            scale={0.21}
          />
          <mesh
            geometry={nodes["3D_Text_-_e_1"].geometry}
            material={nodes["3D_Text_-_e_1"].material}
            position={[8.09, 1.55, 0.12]}
            scale={0.21}
          />
          <mesh
            geometry={nodes["3D_Text_-_m"].geometry}
            material={nodes["3D_Text_-_m"].material}
            position={[-10.13, 1.55, 0.12]}
            scale={0.21}
          />
          <mesh
            geometry={nodes["3D_Text_-_o"].geometry}
            material={nodes["3D_Text_-_o"].material}
            position={[-2.81, 1.55, 0.12]}
            scale={0.21}
          />
          <mesh
            geometry={nodes["3D_Text_-_T"].geometry}
            material={nodes["3D_Text_-_T"].material}
            position={[3.18, 1.55, 0.12]}
            scale={0.21}
          />
          <mesh
            geometry={nodes["3D_Text_-_x"].geometry}
            material={nodes["3D_Text_-_x"].material}
            position={[12.13, 1.55, 0.12]}
            scale={0.21}
          />
          <mesh
            geometry={nodes["3D_Text_-_t"].geometry}
            material={nodes["3D_Text_-_t"].material}
            position={[16.06, 1.55, 0.12]}
            scale={0.21}
          />
        </group>
      </group>
    );
  }

  return (
    <React.Fragment>
      <div className="login-heading">
        <h1 style={{ marginTop: "0px" }}>{t("Vendor Location")}</h1>
        <div style={{ width: "100%", height: "100vh" }}>
          <ReactMapGL
            mapboxAccessToken={TOKEN}
            initialViewState={viewport}
            onViewportChange={(viewport) => setViewport(viewport)}
            mapStyle="mapbox://styles/mapbox/streets-v12"
            transitionDuration="200"
            attributionControl={true}
          >
            {truckCoordinates.map((coordinate, index) => (
              <Marker
                key={index}
                latitude={coordinate.lat}
                longitude={coordinate.lng}
                onClick={() => {
                  setPopupInfo(coordinate);
                  setShowPopUp(true);
                }}
                icon="./img/truck.svg"
              >
                <img
                  src="./img/truck.svg"
                  style={{ width: "45px", height: "45px" }}
                  alt="marker"
                />
              </Marker>
            ))}

            {userCoordinates.map((coordinate, index) => (
              <Marker
                key={index}
                latitude={coordinate.lat}
                longitude={coordinate.lng}
                icon="./img/truck.svg"
              >
                <img
                  src="./img/user.png"
                  style={{ width: "30px", height: "38px" }}
                  alt="marker"
                />
              </Marker>
            ))}

            {showPopUp && (
              <Popup
                latitude={popupInfo.lat}
                longitude={popupInfo.lng}
                onClose={() => {
                  setPopupInfo(null);
                  setShowPopUp(false);
                }}
                closeOnClick={false} // Prevent closing when clicking on the popup
                closeOnClickOutside={false}
              >
                <div>
                  <p className="heading">Truck Information</p>
                  <p>Truck Name: {popupInfo.username}</p>
                </div>
              </Popup>
            )}
          </ReactMapGL>
        </div>

        <div className="wrapper">
          <Canvas camera={{ fov: 70, position: [0, 0, 15] }}>
            <Suspense fallback={null}>
              <ambientLight />
              <directionalLight intensity={2} position={[0, 0, 50]} />
              <Model />
              <OrbitControls
                enablePan={true}
                enableZoom={true}
                enableRotate={true}
              />
            </Suspense>
          </Canvas>
        </div>
      </div>
    </React.Fragment>
  );
}

export default VendorLocation;
